import GraphModal from 'graph-modal';
const modal = new GraphModal();